<template>
    <a-spin :spinning="loading">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" :autoFormCreate="(form) => {
                    this.form = form;
                }
                    ">
                    <a-row :gutter="48">
                        <a-col :md="16" :sm="24">
                            <a-form-item label="用户uid">
                                <a-input placeholder="请扫用户码" disabled v-model="formData.uid" />
                            </a-form-item>
                            <template v-if="userInfo">
                                <div style="color:red;font-size:24px">执行操作前，请务必核对用户ID是否匹配！</div>
                                <a-form-item label="用户ID">
                                    <span style="font-size:36px;font-weight: bold;">{{ userInfo.uid }}</span>
                                </a-form-item>
                                <a-form-item label="用户头像" style="height:128px">
                                    <img class="avatar" :src="userInfo.avatar" alt="avatar" width=128 height=128
                                        style="border-radius:64px;" />
                                </a-form-item>
                                <a-form-item label="用户昵称">
                                    {{ userInfo.nickname }}
                                </a-form-item>
                                <a-form-item label="积分数量">
                                    {{ userInfo.doll }}
                                </a-form-item>
                                <a-form-item label="商品信息" v-if="!stockInfo">
                                    <a-button type="primary" @click="searchGoodsInfo.visible = true">搜索查询商品信息</a-button>
                                    <a-button type="primary" @click="scanGoodsInfo.visible = true"
                                        style="margin-left:12px">扫码获取商品信息</a-button>
                                </a-form-item>
                                <a-form-item label="商品信息" v-else>
                                    <a-row>
                                        <a-col :span="20">
                                            <img :src="stockInfo.pic_url" height="70" width="70"><br />
                                            商品名称：{{ stockInfo.name }}<br />
                                            兑换积分：{{ stockInfo.exchange_price }}
                                        </a-col>
                                        <a-col :span="4">
                                            <a-button type="primary" @click="stockInfo = null">重选商品</a-button>
                                            <a-button type="primary" @click="stockInfo = null; scanGoodsInfo.visible = true"
                                                style="margin-top:12px">继续兑换</a-button>
                                        </a-col>
                                    </a-row>
                                </a-form-item>
                                <a-form-item label="数量">
                                    <a-input-number v-model.number="formData.quantity" :min="0" :max="100000" :step="1"
                                        :precision="0" />
                                </a-form-item>
                            </template>
                        </a-col>
                    </a-row>
                    <a-button v-if="userInfo" type="primary" @click="submit">提交</a-button>
                    <a-button v-if="userInfo" style="margin-left:12px"
                        @click="userInfo = null; formData = { uid: '', quantity: 1 }">重新扫码</a-button>
                </a-form>
            </div>
        </a-card>
        <a-modal v-model="searchGoodsInfo.visible" title="商品信息" :footer="null" :destroyOnClose="true">
            <a-row style="margin-bottom: 24px;">
                <a-col :span="4" style="line-height:32px">
                    商品名称：
                </a-col>
                <a-col :span="14">
                    <a-input v-model="searchGoodsInfo.searchName" placeholder="请输入商品名称"></a-input>
                </a-col>
                <a-col :span="6">
                    <a-button type="primary" style="float:right" @click="search">搜索</a-button>
                </a-col>
            </a-row>
            <s-table ref="table" size="default" :columns="searchGoodsInfo.columns" :data="searchGoodsInfo.loadData">
                <template slot="pic_url" slot-scope="text">
                    <img :src="text" height="70" width="70" />
                </template>
                <template slot="active" slot-scope="text,record">
                    <a @click="setStock(record)">选择</a>
                </template>
            </s-table>
        </a-modal>
        <a-modal v-model="scanGoodsInfo.visible" title="商品信息" :footer="null" :destroyOnClose="true">
            <h1>请扫商品条码</h1>
        </a-modal>
    </a-spin>
</template>
<script>

import { queryUserInfo, rechargeUser } from '@/api/user'
import { getStockList } from "@/api/stock";
import { queryStock, queryStockBy69Code } from "@/api/goods"
import { exchange } from "@/api/purchase"
import { Modal } from 'ant-design-vue'
import STable from "@/components/table/";
import HandleUserAbnormal from './HandleUserAbnormal'

export default {
    components: {
        STable
    },
    mixins: [HandleUserAbnormal],
    name: 'Doll',
    data() {
        return {
            userInfo: null,
            stockInfo: null,
            formData: {
                uid: "",
                quantity: 1,
            },
            key: "",
            keyTimeID: 0,
            loading: false,
            scanGoodsInfo: {
                visible: false,
            },
            searchGoodsInfo: {
                visible: false,
                loadData: (params) => {
                    return getStockList(Object.assign(params, this.queryParam, { not_zero: 1, name: this.searchGoodsInfo.searchName })).then(
                        (res) => res
                    );
                },
                searchName: "",
                columns: [
                    {
                        title: "商品图片",
                        dataIndex: "pic_url",
                        key: "pic_url",
                        width: 70,
                        scopedSlots: { customRender: "pic_url" }
                    },
                    {
                        title: "商品名称",
                        dataIndex: "goods_name",
                        key: "goods_name",
                    },
                    {
                        title: "兑换积分",
                        dataIndex: "exchange_price",
                        key: "exchange_price",
                    },
                    {
                        title: "操作",
                        dataIndex: "active",
                        key: "active",
                        width: 70,
                        scopedSlots: { customRender: "active" }
                    }
                ]
            },
        }
    },
    watch: {
        userInfo: {
            handler(val) {
                if (!this.userInfo) {
                    this.bindWindowScan()
                } else {
                    this.removeWindowScan()
                }
            },
            immediate: true
        },
        "scanGoodsInfo.visible": {
            handler(val) {
                if (val) {
                    this.bindWindowScanGoods()
                } else {
                    this.removeWindowScanGoods()
                }
            },
            immediate: true
        }
    },
    methods: {
        search() {
            this.$refs.table.refresh();
        },
        submit() {
            if (!this.formData.quantity) {
                this.$message.error('兑换数量不能为0');
                return;
            }
            if (!this.stockInfo) {
                this.$message.error('请选择商品');
                return
            }
            Modal.confirm({
                title: '确认兑换',
                content: `确认给用户 ${this.userInfo.nickname} 兑换 ${this.formData.quantity} 个 ${this.stockInfo.name} 吗？`,
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    const { quantity, uid } = this.formData;
                    let userInfo = this.$ls.get("userInfo")
                    this.loading = true
                    exchange({ id: this.stockInfo.id, uid, quantity, admin_user_id: userInfo.id }).then(res => {
                        this.$message.success('操作成功')
                        this.userInfo.doll -= quantity * this.stockInfo.exchange_price
                        this.formData.quantity = 1
                    })
                        .finally(() => {
                            this.loading = false
                        })
                },
            });
        },
        handleScan(e) {
            if (this.keyTimeID) {
                clearTimeout(this.keyTimeID)
            }
            this.keyTimeID = setTimeout(() => {
                this.key = ""
            }, 50)
            this.key += e.key
            if (this.key.indexOf("Enter") > -1) {
                this.key = this.key.replace("Enter", "")
                if (/[^\d]/.test(this.key) || this.key.length < 8 || this.key == "") {
                    return
                }
                this.getUserInfo()
            }
        },
        handleScanGoods(e) {
            if (this.keyTimeID) {
                clearTimeout(this.keyTimeID)
            }
            this.keyTimeID = setTimeout(() => {
                this.key = ""
            }, 50)
            this.key += e.key
            if (this.key.indexOf("Enter") > -1) {
                this.key = this.key.replace("Enter", "")
                if (/[^\d]/.test(this.key) || this.key.length < 12 || this.key == "") {
                    return
                }
                if (this.key.length == 12) {
                    this.getStockInfo(this.key)
                } else if (this.key.length == 13) {
                    this.getStockInfoBy69Code(this.key)
                }
            }
        },
        getStockInfo(stock_id) {
            queryStock(stock_id)
                .then(res => {
                    this.scanGoodsInfo.visible = false
                    this.stockInfo = res
                })
        },
        getStockInfoBy69Code(barcode69) {
            let userInfo = this.$ls.get("userInfo");
            queryStockBy69Code(userInfo.branch_id, barcode69)
                .then(res => {
                    this.scanGoodsInfo.visible = false
                    this.stockInfo = res
                })
        },
        bindWindowScanGoods() {
            window.addEventListener('keydown', this.handleScanGoods);
        },
        removeWindowScanGoods() {
            window.removeEventListener('keydown', this.handleScanGoods);
        },
        bindWindowScan() {
            window.addEventListener('keydown', this.handleScan);
        },
        removeWindowScan() {
            window.removeEventListener('keydown', this.handleScan);
        },
        getUserInfo() {
            this.loading = true
            queryUserInfo({ uid: this.key }).then(res => {
                const { uid, nickname, avatar, id, doll, is_abnormal } = res;
                if (is_abnormal) {
                    this.loading = false
                    this.showAbnormalModal()
                    return
                }
                this.userInfo = {
                    id,
                    uid,
                    nickname,
                    avatar,
                    doll,
                }
                this.formData.uid = uid
                this.formData.quantity = 1
            })
                .finally(() => {
                    this.loading = false
                })
        },
        getStockList() {
            getStockList()
        },
        setStock(record) {
            this.searchGoodsInfo.visible = false
            this.stockInfo = record
            this.stockInfo.name = record.goods_name
        }
    },
    mounted() {
        if (this.$route.params['uid']) {
            this.userInfo = this.$route.params
            this.formData.uid = this.userInfo.uid
        }

    },
    beforeDestroy() {
        this.removeWindowScan()
        this.removeWindowScanGoods()
    }
}
</script>